<template>
  <div class="c-detail-list">
    <section>
      <div
        type="spinner"
        size="24px"
        class="c-list-box"
        v-for="(items, index) in list"
        :key="index"
      >
        <section class="c-content-box">
          <ul class="c-content-ul" v-for="(item, itemIndex) in items.boxLines" :key="itemIndex">
            <li v-for="(line, lineIndex) in item.rowList" :key="lineIndex">
              <span>{{ line.title }} </span>
              <i :class="line.className">{{ line.value }}</i>
            </li>
          </ul>
        </section>
      </div>
    </section>
  </div>
</template>
<script>
import { FormatDate } from "~/script/utils";
export default {
  name: "detailList",
  data() {
    return {
      list: []
    };
  },
  props: {
    listMap: {
      type: Object
    }
  },
  methods: {
    getList(initList) {
      this.list = this.setList(initList);
    },
    // 设置数据
    setList(list) {
      const newList = [];
      if (list.length == 0) return;
      list.forEach((item, index) => {
        let initItem = Object.assign({}, item);
        const newItems = this.setRowData(initItem);
        newList.push(newItems);
      });
      return newList;
    },
    setRowData(initItem) {
      let newItems = JSON.parse(JSON.stringify(this.listMap));
      newItems.Id = initItem.Id;
      let boxLines = newItems.boxLines;
      boxLines.forEach(line => {
        let rowList = line.rowList;
        rowList.forEach(key => {
          if (key.dataType == "Date") {
            key["value"] = FormatDate(initItem[key.banding], "yyyy-MM-dd");
          } else if (key.dataType == "Type") {
            const dataMap = key["dataMap"];
            const classMap = key["classMap"];
            key["value"] = dataMap[initItem[key.banding]];
            if (classMap) {
              key["className"] = classMap[initItem[key.banding]];
            }
          } else {
            key["value"] = initItem[key.banding];
          }
        });
      });
      return newItems;
    }
  }
};
</script>
<style lang="less" scope>
.c-detail-list {
  .c-list-box {
    .c-content-box {
      font-size: 0.12rem;
      border-bottom: 1px dashed #d8d6d6;
      margin-bottom: .1rem;
    }
  }
}
</style>
